import './static-page.css';
import { ThemeToggle, useStaticPageTheme } from './theme-toggle';

export function TermsPage() {
  const { theme, setTheme } = useStaticPageTheme();

  return (
    <div className="static-page">
      <main className="static-page-content">
        <div className="static-page-header">
          <h1>Terms of Use</h1>
          <ThemeToggle theme={theme} setTheme={setTheme} />
        </div>
        <p className="subtitle">Strong's KJV Bible App</p>

        <p>
          By installing or using Strong's KJV ("the App"), you agree to these Terms of Use. If you
          do not agree, please do not use the App.
        </p>

        <h2>The Service</h2>
        <p>
          The App provides access to the King James Version of the Holy Bible, Strong's
          Concordance, related study tools, and AI-assisted features for Bible study and word
          study. The King James Version is in the public domain.
        </p>

        <h2>Permitted Use</h2>
        <p>
          You may use the App for personal, non-commercial Bible study. You agree not to misuse
          the App, attempt to disrupt the Service, or use it for any unlawful purpose.
        </p>

        <h2>AI-Generated Content</h2>
        <p>
          The App includes responses generated by language models. AI-generated content may
          contain errors, omissions, or inaccuracies and should not be relied upon as a
          substitute for personal Bible study, prayer, or counsel from qualified spiritual
          leaders. Always verify any teaching against the Scriptures themselves.
        </p>

        <h2>No Warranty</h2>
        <p>
          THE APP AND THE SERVICE ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF
          ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, OR NON-INFRINGEMENT. WE DO
          NOT WARRANT THAT THE APP WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF HARMFUL
          COMPONENTS.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE PROVIDERS OF THE APP BE
          LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR
          ANY LOSS OF DATA, ARISING OUT OF OR RELATING TO YOUR USE OF, OR INABILITY TO USE, THE
          APP.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these Terms from time to time. Continued use of the App after changes
          take effect constitutes acceptance of the revised Terms.
        </p>

        <h2>Contact Us</h2>
        <p>
          Questions about these Terms? Contact us by{' '}
          <a href="mailto:support@skjv.ai">email</a>.
        </p>

        <footer>
          <a href="/">Strong's KJV</a> · <a href="/privacy">Privacy Policy</a> ·{' '}
          <a href="/support">Support</a>
        </footer>
      </main>
    </div>
  );
}
